module.exports = __webpack_public_path__ + "img/full4-min.c60a5ce2.png";